// removed by extract-text-webpack-plugin
module.exports = {"productBundleList":"G4fa5e3","productImage":"G148e0b","recipeHeader":"G527fe8","title":"G010317","recipeBox":"Gac469d"};